export default {
  fullName: {
    id: 'global_full_name',
    defaultMessage: '{firstName} {lastName}',
  },
  messageSentActionTaken: {
    id: 'bo_sellers_customer_care_table_column_last_action_taken_message_sent',
    defaultMessage: 'Message sent',
  },
  receiptUploadedActionTaken: {
    id: 'bo_sellers_customer_care_table_column_last_action_taken_receipt_uploaded',
    defaultMessage: 'Receipt uploaded',
  },
  repairedReplacedReturnedActionTaken: {
    id: 'bo_sellers_customer_care_table_column_last_action_taken_repaired_replaced_returned',
    defaultMessage: 'Repaired/replaced/returned to customer',
  },
  refundedActionTaken: {
    id: 'bo_sellers_customer_care_table_column_last_action_taken_refunded',
    defaultMessage: 'Refunded',
  },
  problemRaisedActionTaken: {
    id: 'bo_sellers_customer_care_table_column_last_action_taken_problem_raised',
    defaultMessage: 'Problem raised',
  },
  problemApprovedActionTaken: {
    id: 'bo_sellers_customer_care_table_column_last_action_taken_problem_approved',
    defaultMessage: 'Problem approved',
  },
  problemRejectedActionTaken: {
    id: 'bo_sellers_customer_care_table_column_last_action_taken_problem_rejected',
    defaultMessage: 'Problem rejected',
  },
  goToConversationAriaLabel: {
    id: 'bo_sellers_customer_care_table_column_go_to_conversation_aria_label',
    defaultMessage: 'Go to the conversation',
  },
  uploadReceiptButtonLabel: {
    id: 'bo_sellers_customer_care_upload_receipt_button_label',
    defaultMessage: 'Upload receipt',
  },
  uploadSuccessToastLabel: {
    id: 'bo_sellers_customer_care_upload_receipt_success_toast',
    defaultMessage:
      'The receipt for order #{orderId} is uploaded and being confirmed.',
  },
  uploadConfirmationErrorToastLabel: {
    id: 'bo_sellers_customer_care_upload_receipt_fail_toast',
    defaultMessage:
      'Receipt confirmation failed for order #{orderId}.  Please try again.',
  },
  uploadFailedErrorMessage: {
    id: 'bo_sellers_customer_care_previous_upload_receipt_fail_error_message',
    defaultMessage: 'Previous upload failed',
  },
}
